import { BASE_URL, EVO_APP_ID } from '../../constants';
import { createAsyncAction } from '../async/async';
import { getAppropriateToken } from '../../helpers/tokens';
import { authFallback } from '../authentication/authentication';
import { Tenant, CompanyKey, EDCode } from '../../models';
import { request } from '../../helpers/http';

export const LOAD_EDCODES = 'LOAD_EDCODES';

export function loadEDCodes(tenant: Tenant, companyKey: CompanyKey) {
    return createAsyncAction(LOAD_EDCODES, () => getAppropriateToken(tenant.id, EVO_APP_ID)
        .then((token) => Promise.all([
        request({
            url: `${BASE_URL}/v3/api/bureaus/${tenant.subdomain}/clients/${companyKey.clientId}/eds`,
            headers: { Authorization: `Bearer ${token}` },
        }),
        request({
            url: `${BASE_URL}/v3/api/bureaus/${tenant.subdomain}/clients/${companyKey.clientId}/companies/${companyKey.companyId}/eds`,
            headers: { Authorization: `Bearer ${token}` },
        }),
    ])).then(([ { results: clientEDs }, { results: companyEDs } ]) => {
        const idSet = new Set(companyEDs.map((ed: any) => ed.clientEdId));
        const edCodes = clientEDs.filter((ed: any) => idSet.has(ed.id) && isApplicableType(ed));
        return { companyKey, edCodes };
    }), authFallback);
}

// only map E/D codes of types E*, M*, DL, DM, DO
function isApplicableType(ed: EDCode) {
    return (
        ed.codeType.startsWith('E') ||
        ed.codeType.startsWith('M') ||
        [ 'DL', 'DM', 'DO', 'DV', 'DW' ].indexOf(ed.codeType) > -1
    );
}
